import { render, staticRenderFns } from "./VideoScripts.vue?vue&type=template&id=02047583&scoped=true&"
import script from "./VideoScripts.vue?vue&type=script&lang=js&"
export * from "./VideoScripts.vue?vue&type=script&lang=js&"
import style0 from "./VideoScripts.vue?vue&type=style&index=0&id=02047583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02047583",
  null
  
)

export default component.exports